import styled from 'styled-components/native';
import { defaultTheme as theme } from '../../styles/theme';

export const Error = styled.Text`
    color: ${theme.colors.red};
    font-size: 10px;
    margin-top: 4px;
    font-family: ${theme.font.regular};
`;
